import { tx } from "@/i18n/tx";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { AppShell, Loader } from "@/components/AppShell";
import { Sparkles } from "lucide-react";

export default function Percorso() {
  const [summary, setSummary] = useState(null);

  useEffect(() => { api.get("/weekly-summary").then((r) => setSummary(r.data)).catch(() => setSummary({ available: false })); }, []);
  if (!summary) return <Loader />;

  return (
    <AppShell>
      <div className="px-7 pt-12">
        <h1 className="font-serif text-4xl text-anima-ink mb-2">{tx("Il tuo percorso")}</h1>
        <p className="text-anima-muted mb-8 text-sm">{tx("Una sintesi delicata di cio che hai attraversato.")}</p>

        {!summary.available ? (
          <div className="anima-card rounded-3xl p-8 text-center">
            <Sparkles size={26} className="text-anima-sagedeep mx-auto mb-3" />
            <p className="font-serif text-2xl text-anima-ink mb-2">{tx("La sintesi arrivera presto")}</p>
            <p className="text-sm text-anima-muted mb-5">{tx("Continua ad ascoltarti per qualche giorno: dopo alcune riflessioni potrai vedere qui i tuoi temi ricorrenti.")}</p>
            <Link to="/app" className="inline-block rounded-full bg-anima-sagedeep text-anima-ivory px-6 py-3 text-sm">{tx("Vai alla domanda di oggi")}</Link>
          </div>
        ) : (
          <div className="space-y-6">
            <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="rounded-3xl bg-anima-pinklight/80 border border-anima-ink/5 p-6">
              <p className="text-[11px] uppercase tracking-widest text-anima-muted mb-1">{tx("Questa settimana")}</p>
              <p className="font-serif text-2xl text-anima-ink">{summary.progress}</p>
            </motion.div>

            {summary.themes?.length > 0 && (
              <div>
                <p className="text-[11px] uppercase tracking-widest text-anima-golddeep mb-2">{tx("Temi piu presenti")}</p>
                <div className="flex flex-wrap gap-2">
                  {summary.themes.map((t) => (
                    <span key={t} className="rounded-full bg-anima-sage/25 text-anima-ink px-4 py-2 text-sm capitalize">{t}</span>
                  ))}
                </div>
              </div>
            )}

            {summary.symbols?.length > 0 && (
              <div>
                <p className="text-[11px] uppercase tracking-widest text-anima-golddeep mb-2">{tx("Simboli ricorrenti")}</p>
                <div className="flex flex-wrap gap-2">
                  {summary.symbols.map((s) => (
                    <span key={s} className="rounded-full bg-anima-gold/25 text-anima-ink px-4 py-2 text-sm">{s}</span>
                  ))}
                </div>
              </div>
            )}

            <div className="rounded-3xl bg-anima-sage/20 border border-anima-sage/30 p-6">
              <p className="text-[11px] uppercase tracking-widest text-anima-golddeep mb-2">{tx("Una domanda per la prossima settimana")}</p>
              <p className="font-serif text-2xl text-anima-ink leading-snug">{summary.next_question}</p>
            </div>
          </div>
        )}
      </div>
    </AppShell>
  );
}
